interface DiscoveryKPI {
  order: number;
  importance: number;
  definition: {
    name: string;
  };
  lowImpactValue?: number | null;
  expectedImpactValue?: number | null;
  potentialImpactValue?: number | null;
}

interface DiscoveryChallenge {
  order: number;
  importance: number;
  definition: {
    description: string;
  };
}

export const sortDiscoveryKPIsByOrder = (
  a: DiscoveryKPI,
  b: DiscoveryKPI
): number => {
  const order = a.order - b.order;

  return order !== 0
    ? order
    : a.definition.name.localeCompare(b.definition.name);
};

export const sortDiscoveryKPIsByImportance = (
  a: DiscoveryKPI,
  b: DiscoveryKPI
): number => {
  const importance = b.importance - a.importance;

  if (importance !== 0) {
    return importance;
  }

  return sortDiscoveryKPIsByOrder(a, b);
};

export const sortDiscoveryChallengesByOrder = (
  a: DiscoveryChallenge,
  b: DiscoveryChallenge
): number => {
  const order = a.order - b.order;

  return order !== 0
    ? order
    : a.definition.description.localeCompare(b.definition.description);
};

export const sortDiscoveryChallengesByImportance = (
  a: DiscoveryChallenge,
  b: DiscoveryChallenge
): number => {
  const importance = b.importance - a.importance;

  if (importance !== 0) {
    return importance;
  }

  return sortDiscoveryChallengesByOrder(a, b);
};

export const sortDiscoveryKPIsByValue =
  (scenario: number) =>
  (a: DiscoveryKPI, b: DiscoveryKPI): number => {
    // Map scenario values to field names
    let scenarioField:
      | "lowImpactValue"
      | "potentialImpactValue"
      | "expectedImpactValue";
    if (scenario === 0) {
      scenarioField = "lowImpactValue";
    } else if (scenario === 100) {
      scenarioField = "potentialImpactValue";
    } else {
      scenarioField = "expectedImpactValue"; // default for 50 or null/undefined
    }

    const aValue = a[scenarioField];
    const bValue = b[scenarioField];

    const aHasValue = aValue !== null && aValue !== undefined;
    const bHasValue = bValue !== null && bValue !== undefined;

    // Both have $$$ values - sort by value descending
    if (aHasValue && bHasValue) {
      return bValue - aValue;
    }

    // Only one has $$$ value - that one comes first
    if (aHasValue) return -1;
    if (bHasValue) return 1;

    // Neither has $$$ value - sort by importance then order
    return sortDiscoveryKPIsByImportance(a, b);
  };
